import { Component } from '@angular/core';

@Component({
  selector: 'button-group-specs',
  templateUrl: './button-group-specs.component.html',
  styleUrls: ['./button-group-specs.component.sass']
})
export class ButtonGroupSpecsComponent {
  public component = window.location.protocol + '//' + window.location.host + '/design-specs-measure/buttongroup/';
  constructor() { }

  ngOnInit(): void {
  }

  clickEvent(route) {
    if(route == 'light') {
      window.open(this.component, "_blank");
    }
  }
}
